// TODO: refactor and optimize this class!
class FilterForm {
	constructor(el, opts) {
		if (!el) {
			console.error('FilterForm class constructor requires "el" argument!');
			return;
		}

		// restoreFilterFormInputs();

		const submitHandler = _.debounce(opts.submitHandler, 700);

		let $filterForm = $(el);
		let flatsMobileSorter   = $('[data-sort-flats-select]');
		let typicalMobileSorter = $('[data-sort-typicals-select]');

		this.flatsFrom = 0;
		this.flatsTo = flatsPerPage;
		this.$filterForm = $filterForm;
		this.restoreStateFromURL();


		if (!$filterForm.length) {
			console.error('FilterForm constructor can\'t find given "el" in DOM!');
			return;
		}

		if ( flatsMobileSorter.length ) {
			new SlimSelect({
				select: flatsMobileSorter[0],
				showSearch: false
			});
		}

		if ( typicalMobileSorter.length ) {
			new SlimSelect({
				select: typicalMobileSorter[0],
				showSearch: false
			});
		}

		let multycheckboxes = [];

		$(".Multycheckbox").each((index, el) => {
			multycheckboxes.push(new Multicheckbox(el));
		});
		$("[data-checkbox]").each((index, el) => {
			multycheckboxes.push(new Multicheckbox(el));
		});

		const rangeSliders = document.querySelectorAll('[data-slider-range]');
		rangeSliders.forEach(function (slider, index) {
			new RangeSliderChoose(slider);
		});


		let $inputs = $($filterForm.get(0).elements);

		$inputs.on("change", event => {
			event.preventDefault();
			this.flatsFrom = 0;
			this.flatsTo = flatsPerPage;
			$inputs.blur();
			$filterForm.trigger("submit");
		});

		$filterForm.on("submit", (event) => {
			event.preventDefault();
			submitHandler($filterForm);
			this.saveStateToURL();
			return false;
		});

		this.$inputs = $inputs;
		this.rangeSliders = rangeSliders;
		this.multycheckboxes = multycheckboxes;
		this.tooltips = null;
		$filterForm.trigger("submit");
	}

	resetFilterForm() {
		this.$filterForm[0].reset();
		this.rangeSliders.forEach(rangeSliderInst => {
			let min = rangeSliderInst.noUiSlider.options.range.min;
			let max = rangeSliderInst.noUiSlider.options.range.max;
			rangeSliderInst.noUiSlider.set([min, max]);
		});

		this.multycheckboxes.forEach(multiCheckboxInst => {
			multiCheckboxInst.reset();
		});
	}

	saveStateToURL() {
		let queryStr = this.$filterForm.serialize();
		let newURL = location.pathname + "?" + queryStr;
		history.replaceState({}, document.title, newURL);
	}

	restoreStateFromURL() {
		let storedValues = parseQueryString(window.location.search);

		// console.log("restored form states:", storedValues);

		let $inps = $(this.$filterForm.get(0).elements);

		for (let p in storedValues) {
			if (storedValues.offset) {
				this.offset = storedValues.offset;
			}
			// TODO: optimize selector for filtering inputs
			$inps.filter(`[name='${p}'], [name='${p}[]']`).each((index, el) => {
				if (el.type && (el.type === "checkbox" || el.type === "radio")) {
					let isChecked = true;

					if (_.isArray(storedValues[p])) {
						isChecked = _.includes(storedValues[p], el.value);
					}

					el.checked = isChecked;
				} else if (el.tagName === "SELECT") {
					if (storedValues[p]) {
						for (var i = 0; i < el.options.length; i++) {
							let opt = el.options[i];
							if (storedValues[p].includes(opt.value)) {
								opt.selected = "selected";
							}
						}
					}
				} else {
					el.value = storedValues[p];
				}
			});
		}
	}
}
